import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@/components/data-grid';
import type { ColumnFilterGroup } from '@/components/data-grid';
import { ROUTES } from '@/app/routes';
import type { PostManagerResponseDTO } from '@/api/generated/model';
import { usePipelineTestList } from '../api';
import { contentColumns } from '../columns';
import { ContentInfrastructureHealth } from '../components/ContentInfrastructureHealth';

// Same type chips as Content Management — codes map to PostRequestDTO.postTypes[].
// Live broadcasts are not pipeline-test content.
const TYPE_FILTER: ColumnFilterGroup = {
  columnKey: 'type',
  label: 'Type',
  options: [
    { key: 'N', label: 'Post' },
    { key: 'I', label: 'Images' },
    { key: 'E', label: 'Exclusive' },
    { key: 'S', label: 'Story' },
    { key: 'F', label: 'Flicks' },
    { key: 'M', label: 'Message' },
  ],
};

/**
 * Dedicated list for admin Pipeline Test harness posts (excluded from /content).
 */
export function PipelineTestListPage() {
  const navigate = useNavigate();
  const table = usePipelineTestList();

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      <div className="flex justify-end">
        <ContentInfrastructureHealth />
      </div>
      <div className="min-h-0 flex-1">
        <DataGrid<PostManagerResponseDTO>
          title="Pipeline Tests"
          searchPlaceholder="Search pipeline test posts…"
          columns={contentColumns}
          rows={table.rows}
          total={table.total}
          isLoading={table.isLoading}
          isFetchingNextPage={table.isFetchingNextPage}
          isError={table.isError}
          error={table.error}
          endReached={table.endReached}
          page={table.page}
          totalPage={table.totalPage}
          onPageChange={table.setPage}
          isFetching={table.isFetching}
          onLoadMore={table.fetchNextPage}
          onRetry={() => void table.refetch()}
          search={table.search}
          onSearchChange={table.setSearch}
          filterGroups={[TYPE_FILTER]}
          selectedFilters={table.filters}
          onFiltersChange={table.setFilters}
          getRowId={(r) => String(r.id)}
          onRowClick={(r) => void navigate(ROUTES.contentDetails(String(r.id)))}
          showAddButton={true}
          addButtonText="New Pipeline Test"
          onAddClick={() => void navigate(ROUTES.createTestPost)}
          emptyMessage="No pipeline test posts yet"
          onSortChange={table.toggleSort}
          sortableColumns={['earnings', 'time']}
          sortState={table.sort}
        />
      </div>
    </div>
  );
}
